import Patient from './Patients/reducers';
import { combineReducers } from 'redux';

const appReducer = combineReducers({
  Patient
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_STATE') {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
